import { NavigationGuard } from "vue-router";
import { useBroadcastPortalAuthStore } from "../store";

export const userMustBeLoggedIn: NavigationGuard = (to, from, next) => {
    const authStore = useBroadcastPortalAuthStore();

    const destinationPath = to.fullPath;

    const isLoggedIn = !!authStore.auth.productionHouseMember || !!authStore.auth.freelanceMember;

    if (isLoggedIn && authStore.hasAccessToken !== '') {
        if (!authStore.hasCompletedRegistration) {
            const isFreelancer = authStore.member?.typeAlias === 'freelanceMember';
            if (isFreelancer) {
                next({ name: 'freelancer-registration' });
                return;
            }
            next({ name: 'production-house-registration' });
            return;
        }
        next();
        return;
    }

    next({
        name: 'sign-in',
        query: {
            ref: destinationPath
        }
    })
}

export const userMustHaveApproval: NavigationGuard = (to, from, next) => {
    const authStore = useBroadcastPortalAuthStore();

    // if not approve, cannot go next, go to settings
     if (authStore.member?.approvalStatus?.name === 'Under Review' || authStore.member?.approvalStatus?.name === 'Rejected') {
        next({ name: 'settings' });
        return;
    }
    // if got approval. then can go next
    next();
    return;
}